module.exports = __webpack_public_path__ + "media/images/home/card-6187d73a2d7ebb072f37ae572cc9cac2.svg";